import Vue from "vue";
import VueRouter from "vue-router";
/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

// 路由懒加载
const Login = () => import("../views/Login.vue");
const Index = () => import("../views/Index.vue");
const Welcome = () => import("../views/auth/index/Welcome.vue");
const RoleMenu = () => import("../views/auth/roleMenu/RoleMenu.vue");
const ComponeyManger = () => import("../views/auth/componeyManger/componeyManger.vue");

const employeeManagement = () =>
  import("../views/auth/employee/EmployeeManagement.vue");
const employeeDetail = () =>
  import("../views/auth/employee/EmployeeDetail.vue");
const OrganizationManagement = () =>
  import("../views/auth/organization/OrganizationManagement.vue");
const Post = () => import("../views/auth/post/Post.vue");
const Menu = () => import("../views/auth/menu/Menu.vue");
const Authority = () => import("../views/auth/authority/Authority.vue");
const OrganizationTypeMaintenance = () =>
  import("../views/auth/organizationType/OrganizationType.vue");
const myAccountView = () => import("../views/auth/my/MyAccountView.vue");
const SystemConfig = () => import("../views/systemConfig/SystemConfig.vue");
const SystemConfigDetails = () =>
  import("../views/systemConfig/SystemConfigDetails.vue");
const TableDesign = () => import("../views/coding/tableDesign/TableDesign.vue");
const Table = () => import('../views/coding/table/Table.vue')
const TableDetails = () => import('../views/coding/table/TableDetails.vue')
const TableDdl = () => import('../views/coding/tableDdl/TableDdl.vue')
const TableDdlDetails = () => import('../views/coding/tableDdl/TableDdlDetails.vue')


const LoginLog = () => import('../views/loginLog/LoginLog.vue')
const LoginLogDetails = () => import('../views/loginLog/LoginLogDetails.vue')


const MemberCaseRelation = () => import('../views/memberCaseRelation/MemberCaseRelation.vue')
const MemberCaseRelationDetails = () => import('../views/memberCaseRelation/MemberCaseRelationDetails.vue')
const SystemNotice = () => import('../views/systemNotice/SystemNotice.vue')
const SystemNoticeDetails = () => import('../views/systemNotice/SystemNoticeDetails.vue')
const Video = () => import('../views/video/Video.vue')
const VideoDetails = () => import('../views/video/VideoDetails.vue')
const TrainingApply = () => import('../views/trainingApply/TrainingApply.vue')
const TrainingApplyDetails = () => import('../views/trainingApply/TrainingApplyDetails.vue')
const PvCase = () => import('../views/pvCase/PvCase.vue')
const PvCaseDetails = () => import('../views/pvCase/PvCaseDetails.vue')
const ProjectImage = () => import('../views/projectImage/ProjectImage.vue')
const ProjectImageDetails = () => import('../views/projectImage/ProjectImageDetails.vue')

const PolicyImage = () => import('../views/policyImg/ProjectImage.vue')
const PolicyImageDetails = () => import('../views/policyImg/ProjectImageDetails.vue')

const Member = () => import('../views/member/Member.vue')
const MemberDetails = () => import('../views/member/MemberDetails.vue')
const InvestorApply = () => import('../views/investorApply/InvestorApply.vue')
const InvestorApplyDetails = () => import('../views/investorApply/InvestorApplyDetails.vue')
const InstallApply = () => import('../views/installApply/InstallApply.vue')
const InstallApplyDetails = () => import('../views/installApply/InstallApplyDetails.vue')
const Dict = () => import('../views/dict/Dict.vue')
const DictDetails = () => import('../views/dict/DictDetails.vue')
const Company = () => import('../views/company/Company.vue')
const CompanyDetails = () => import('../views/company/CompanyDetails.vue')
const BargainRecords = () => import('../views/bargainRecords/BargainRecords.vue')
const BargainRecordsDetails = () => import('../views/bargainRecords/BargainRecordsDetails.vue')
const AuditRecords = () => import('../views/auditRecords/AuditRecords.vue')
const AuditRecordsDetails = () => import('../views/auditRecords/AuditRecordsDetails.vue')
const AccessRecords = () => import('../views/accessRecords/AccessRecords.vue')
const AccessRecordsDetails = () => import('../views/accessRecords/AccessRecordsDetails.vue')
const Project = () => import('../views/project/Project.vue')
const ProjectDetails = () => import('../views/project/ProjectDetails.vue')
const InvestorLabel = () => import('../views/investorLabel/InvestorLabel.vue')
const InvestorLabelDetails = () => import('../views/investorLabel/InvestorLabelDetails.vue')
const DictCompleteProject = () => import('../views/dictCompleteProject/DictCompleteProject.vue')
const DictCompleteProjectDetails = () => import('../views/dictCompleteProject/DictCompleteProjectDetails.vue')
const Policy = () => import('../views/policy/Policy.vue')
const PolicyDetails = () => import('../views/policy/PolicyDetails.vue')

const PublishedProject = () => import('../views/accessRecords/PublishedProject.vue')
const PublichProjectDetails = () => import('../views/accessRecords/PublichProjectDetails.vue')
const DownloadApply = () => import('../views/downloadApply/DownloadApply.vue')

const Screen = () => import('../views/screen/Screen.vue')

const ZhongliangConfig = () => import('../views/zhongliangConfig/ZhongliangConfig.vue')
const ZhongliangConfigDetails = () => import('../views/zhongliangConfig/ZhongliangConfigDetails.vue')

const DictOfflineCompleteProject = () => import('../views/dictOfflineCompleteProject/DictOfflineCompleteProject.vue')
const DictOfflineCompleteProjectDetails = () => import('../views/dictOfflineCompleteProject/DictOfflineCompleteProjectDetails.vue')
const ElectricityPrice = () => import('../views/electricityPrice/ElectricityPrice.vue')
const ElectricityPriceDetails = () => import('../views/electricityPrice/ElectricityPriceDetails.vue')

const CallRecordsCalculate = () => import('../views/callRecordsCalculate/CallRecordsCalculate.vue')
const CallRecordsCalculateDetails = () => import('../views/callRecordsCalculate/CallRecordsCalculateDetails.vue')
const CallRecordsElectricityPrice = () => import('../views/callRecordsElectricityPrice/CallRecordsElectricityPrice.vue')
const CallRecordsElectricityPriceDetails = () => import('../views/callRecordsElectricityPrice/CallRecordsElectricityPriceDetails.vue')
const CallRecordsMeasureMap = () => import('../views/callRecordsMeasureMap/CallRecordsMeasureMap.vue')
const CallRecordsMeasureMapDetails = () => import('../views/callRecordsMeasureMap/CallRecordsMeasureMapDetails.vue')
const CallRecordsQcc = () => import('../views/callRecordsQcc/CallRecordsQcc.vue')
const CallRecordsQccDetails = () => import('../views/callRecordsQcc/CallRecordsQccDetails.vue')
const MeasureSearchHistory = () => import('../views/measureSearchHistory/MeasureSearchHistory.vue')
const MeasureSearchHistoryDetails = () => import('../views/measureSearchHistory/MeasureSearchHistoryDetails.vue')
const QccSearchHistory = () => import('../views/qccSearchHistory/QccSearchHistory.vue')
const QccSearchHistoryDetails = () => import('../views/qccSearchHistory/QccSearchHistoryDetails.vue')
const ElectricityPriceTime = () => import('../views/electricityPriceTime/ElectricityPriceTime.vue')
const ElectricityPriceTimeDetails = () => import('../views/electricityPriceTime/ElectricityPriceTimeDetails.vue')
const MemberOpinion = () => import('../views/memberOpinion/MemberOpinion.vue')
const MemberOpinionDetails = () => import('../views/memberOpinion/MemberOpinionDetails.vue')
const ProjectChuNeng = () => import('../views/project/ProjectChuNeng.vue')
const ProjectDiMian = () => import('../views/project/ProjectDiMian.vue')
const ProjectDetailsChuNeng = () => import('../views/project/ProjectDetailsChuNeng.vue')
const ProjectDetailsDiMian = () => import('../views/project/ProjectDetailsDiMian.vue')
const InvestorManage = () => import('../views/investorManage/InvestorManage.vue')

const operationLog = () => import('../views/project/operationLog.vue')
Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/index" },
  { path: "/login", component: Login },
  {
    path: "/index",
    component: Index,
    redirect: "/Welcome",
    children: [
      { path: "/index", component: Welcome },
      { path: "/employee", component: employeeManagement },
      { path: "/employee/details", component: employeeDetail },
      { path: "/organization", component: OrganizationManagement },
      { path: "/post", component: Post },
      { path: "/menu", component: Menu },
      { path: "/authority", component: Authority },
      { path: '/componeyManger', component: ComponeyManger },
      { path: "/organizationType", component: OrganizationTypeMaintenance },
      { path: "/myAccountView", component: myAccountView },
      { path: "/roleMenu", component: RoleMenu },
      { path: "/systemConfig", component: SystemConfig },
      { path: "/systemConfig/details", component: SystemConfigDetails },
      { path: "/tableDesign", component: TableDesign },
      { path: '/coding', component: Table },
      { path: '/table/details', component: TableDetails },
      { path: '/tableDdl', component: TableDdl },
      { path: '/tableDdl/details', component: TableDdlDetails },
      { path: '/loginLog', component: LoginLog },
      { path: '/loginLog/details', component: LoginLogDetails },
      { path: '/memberCaseRelation', component: MemberCaseRelation },
      { path: '/memberCaseRelation/details', component: MemberCaseRelationDetails },
      { path: '/systemNotice', component: SystemNotice },
      { path: '/systemNotice/details', component: SystemNoticeDetails },
      { path: '/video', component: Video },
      { path: '/video/details', component: VideoDetails },
      { path: '/trainingApply', component: TrainingApply },
      { path: '/trainingApply/details', component: TrainingApplyDetails },
      { path: '/pvCase', component: PvCase },
      { path: '/pvCase/details', component: PvCaseDetails },
      { path: '/projectImage', component: ProjectImage },
      { path: '/projectImage/details', component: ProjectImageDetails },
      { path: '/policyImg', component: PolicyImage },
      { path: '/policyImg/details', component: PolicyImageDetails },
      { path: '/member', component: Member },
      { path: '/member/details', component: MemberDetails },
      { path: '/investorApply', component: InvestorApply },
      { path: '/investorApply/details', component: InvestorApplyDetails },
      { path: '/installApply', component: InstallApply },
      { path: '/installApply/details', component: InstallApplyDetails },
      { path: '/dict', component: Dict },
      { path: '/dict/details', component: DictDetails },
      { path: '/company', component: Company },
      { path: '/company/details', component: CompanyDetails },
      { path: '/bargainRecords', component: BargainRecords },
      { path: '/bargainRecords/details', component: BargainRecordsDetails },
      { path: '/auditRecords', component: AuditRecords },
      { path: '/auditRecords/details', component: AuditRecordsDetails },
      { path: '/accessRecords', component: PublishedProject },
      { path: '/accessRecords/details', component: PublichProjectDetails },
      { path: '/operationLog', component: operationLog },
      { path: '/project', component: Project, name: 'Project', meta: { keepAlive: true } },
      { path: '/project/details', component: ProjectDetails },
      { path: '/investorLabel', component: InvestorLabel },
      { path: '/investorLabel/details', component: InvestorLabelDetails },
      { path: '/dictCompleteProject', component: DictCompleteProject },
      { path: '/dictCompleteProject/details', component: DictCompleteProjectDetails },
      { path: '/policy', component: Policy },
      { path: '/policy/details', component: PolicyDetails },
      { path: '/downloadApply', component: DownloadApply },

      { path: '/zhongliangConfig', component: ZhongliangConfig },
      { path: '/zhongliangConfig/details', component: ZhongliangConfigDetails },

      { path: '/dictOfflineCompleteProject', component: DictOfflineCompleteProject },
      { path: '/dictOfflineCompleteProject/details', component: DictOfflineCompleteProjectDetails },
      { path: '/electricityPrice', component: ElectricityPrice },
      { path: '/electricityPrice/details', component: ElectricityPriceDetails },

      { path: '/callRecordsCalculate', component: CallRecordsCalculate },
      { path: '/callRecordsCalculate/details', component: CallRecordsCalculateDetails },
      { path: '/callRecordsElectricityPrice', component: CallRecordsElectricityPrice },
      { path: '/callRecordsElectricityPrice/details', component: CallRecordsElectricityPriceDetails },
      { path: '/callRecordsMeasureMap', component: CallRecordsMeasureMap },
      { path: '/callRecordsMeasureMap/details', component: CallRecordsMeasureMapDetails },
      { path: '/callRecordsQcc', component: CallRecordsQcc },
      { path: '/callRecordsQcc/details', component: CallRecordsQccDetails },
      { path: '/measureSearchHistory', component: MeasureSearchHistory },
      { path: '/measureSearchHistory/details', component: MeasureSearchHistoryDetails },
      { path: '/qccSearchHistory', component: QccSearchHistory },
      { path: '/qccSearchHistory/details', component: QccSearchHistoryDetails },
      { path: '/electricityPriceTime', component: ElectricityPriceTime },
      { path: '/electricityPriceTime/details', component: ElectricityPriceTimeDetails },
      { path: '/memberOpinion', component: MemberOpinion },
      { path: '/memberOpinion/details', component: MemberOpinionDetails },
      { path: '/projectChuNeng', component: ProjectChuNeng, name: 'ProjectChuNeng', },
      { path: '/projectDiMian', component: ProjectDiMian, name: 'ProjectDiMian' },
      { path: '/project/detailsChuNeng', component: ProjectDetailsChuNeng },
      { path: '/project/detailsDiMian', component: ProjectDetailsDiMian },
      { path: "/investorManage", component: InvestorManage }
    ]
  },
  { path: "/screen", component: Screen }
];


const router = new VueRouter({
  routes
});

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    let token = ""; //token保存在localstorage中

    let item = localStorage.getItem("token");
    // 先将拿到的试着进行json转为对象的形式
    try {
      item = JSON.parse(item);
    } catch (error) {
      // eslint-disable-next-line no-self-assign
      item = item;
    }
    if (item && item.startTime) {
      let date = new Date().getTime();
      // 如果大于就是过期了，如果小于或等于就还没过期
      let timel = date - item.startTime;
      console.log("timelength:" + timel + ",expires:" + item.expires);
      if (timel < item.expires) {
        token = item.value;
      }
    }
    if (token === null || token === "") {
      next("/login");
    } else {

      next();
    }
  }
});

export default router;
